var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 81.664 1.376 C 81.664 0.616 81.052 0 80.297 0 L 2.031 0 C 1.276 0 0.664 0.616 0.664 1.376 L 0.664 52.624 C 0.664 53.384 1.276 54 2.031 54 L 80.297 54 C 81.052 54 81.664 53.384 81.664 52.624 L 81.664 1.376 Z M 41.164 36.364 L 5.418 2.752 L 76.904 2.752 L 41.164 36.364 Z M 27.078 26.92 L 3.398 49.355 L 3.398 4.654 L 27.078 26.92 Z M 29.081 28.82 L 40.231 39.296 C 40.758 39.787 41.573 39.784 42.097 39.29 L 53.676 28.417 L 76.973 51.248 L 5.427 51.248 L 29.081 28.82 Z M 55.676 26.517 L 78.93 4.649 L 78.93 49.289 L 55.676 26.517 Z","id":"Shape","fill":"#FFFFFF","fillRule":"nonzero","stroke":"none","strokeWidth":"1"}));
}

Mail.defaultProps = {"width":"82px","height":"54px","viewBox":"0 0 82 54","version":"1.1"};

module.exports = Mail;

Mail.default = Mail;
